import { BriefClassificationResponse } from '../api';
import { useBriefCreationContext } from '../context/BriefCreationContext';
import {
    PostAndPollAdditionalDataParams,
    usePostAndPollAdditionalData,
} from './classification/usePostAndPollAdditionalData';

export const useExtractPersonBriefAdditionalData = () => {
    const { isLoading, postAndPollAdditionalData } = usePostAndPollAdditionalData();
    const { setBriefClassification } = useBriefCreationContext();

    const extractAdditionalData = async ({
        leafClassification,
        userInput,
        contextId,
        abortController,
        flowRetries = 0,
        requestType,
    }: Pick<
        PostAndPollAdditionalDataParams,
        'abortController' | 'contextId' | 'userInput' | 'leafClassification' | 'flowRetries' | 'requestType'
    >): Promise<BriefClassificationResponse | undefined> => {
        if (!leafClassification) {
            return;
        }

        const additionalData = await postAndPollAdditionalData({
            requestType,
            leafClassification,
            userInput,
            contextId,
            extractors: ['METADATA', 'BUDGET', 'DELIVERY_TIME', 'SELLER_PREFERENCES'],
            abortController,
            flowRetries,
        });

        if (additionalData) {
            setBriefClassification(additionalData);
        }

        return additionalData;
    };

    return {
        isLoading,
        extractAdditionalData,
    };
};
